import React from "react";
import "../styles/logo.css";
function Logo() {
  return (
    <div className="LogoWrapper">
      <img className="Logo" src="/assets/title_logo.png" alt="TO DO LIST" />
    </div>
  );
}

export default Logo;
